import styled           from 'styled-components';

import { themeColors, 
         cssFlexRow   } from 'src/providers/theme/shared';



type ReportLookAndFeel = {
  paddings: number[];
  innerGap: number;
  iconSize: number;
  iconMargin: number;

  backgroundColor: string;
  borderColor: string;
  iconBorderColor: string;
  iconColor: string;
}

const report_light: ReportLookAndFeel = {
  paddings: [16, 18, 16, 18],
  innerGap: 8,
  iconSize: 24,
  iconMargin: 0,

  backgroundColor: themeColors.PrimaryWhite,
  borderColor: themeColors.BorderSecondary,
  iconBorderColor: themeColors.CardBorderColor,
  iconColor: themeColors.AccentBlue2,
}

export type ReportVariants = 'light';

export const report_variants: Map<ReportVariants, ReportLookAndFeel> = 
  new Map<ReportVariants, ReportLookAndFeel>([
    ['light', report_light],
  ]);

export const Container = styled.div<{
  lookAndFeel: ReportLookAndFeel
}>`
  ${cssFlexRow};
  width: 100%;
  gap: ${(args) => args.lookAndFeel.innerGap}px;
  padding: ${(args) => args.lookAndFeel.paddings[0]}px
           ${(args) => args.lookAndFeel.paddings[1]}px
           ${(args) => args.lookAndFeel.paddings[2]}px
           ${(args) => args.lookAndFeel.paddings[3]}px;

  background-color: ${(args) => args.lookAndFeel.backgroundColor};
  border: 1px solid ${(args) => args.lookAndFeel.borderColor};
  border-radius: 16px;
  align-items: center;
`

export const Icon = styled.span<{
  lookAndFeel: ReportLookAndFeel,
}>`
  ${cssFlexRow};
  width: ${(args) => args.lookAndFeel.iconSize}px;
  height: ${(args) => args.lookAndFeel.iconSize}px;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  margin: ${(args) => args.lookAndFeel.iconMargin}px;
  color: ${(args) => args.lookAndFeel.iconColor};
`;

export const VStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-grow: 1;
`
